import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { GradebookAppContext } from "./GradebookAppContext.js";
export var GradebookAppProvider = function GradebookAppProvider(_ref) {
  var children = _ref.children,
    _ref$settings = _ref.settings,
    originalSettings = _ref$settings.settings,
    onSave = _ref$settings.onSave;
  var _useState = useState(originalSettings),
    _useState2 = _slicedToArray(_useState, 2),
    settings = _useState2[0],
    setSettings = _useState2[1];
  var value = {
    // If the settings will be implemented on the app level, we can remove this (MC won't use it)
    settings: {
      settings: settings,
      setSettings: setSettings,
      onSave: onSave
    }
  };
  return /*#__PURE__*/React.createElement(GradebookAppContext.Provider, {
    value: value
  }, children);
};